import { Link } from '@inertiajs/react'
import { Bot } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  PROFILE_DESCRIPTIONS,
  PROFILE_ICONS,
  PROFILE_LABELS,
  SELECTABLE_PROFILE_IDS,
} from '@/frontend/pages/Dashboard/DigitalWorkers/constants'

const ROLE_CARDS = SELECTABLE_PROFILE_IDS.map((profile) => ({
  icon: PROFILE_ICONS[profile],
  title: PROFILE_LABELS[profile],
  description: PROFILE_DESCRIPTIONS[profile],
}))

// Estado 0 agentes: convite para contratar o primeiro colaborador digital.
// Sem composer — não há com quem conversar ainda.
export function EmptyTeamState() {
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <div className="flex size-14 items-center justify-center rounded-2xl bg-brand/10 text-brand">
          <Bot className="size-7" aria-hidden />
        </div>
        <div className="space-y-1">
          <h2 className="text-lg font-semibold tracking-tight text-foreground">
            Contrate seu primeiro colaborador digital
          </h2>
          <p className="text-sm text-muted-foreground">
            Trabalham com o seu time todos os dias. Você acompanha tudo por aqui.
          </p>
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {ROLE_CARDS.map(({ icon: Icon, title, description }) => (
          <div key={title} className="rounded-xl border border-border bg-card p-4">
            <Icon className="h-5 w-5 text-primary" strokeWidth={1.75} />
            <h3 className="mt-3 text-sm font-medium text-foreground">{title}</h3>
            <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{description}</p>
          </div>
        ))}
      </div>
      <Button asChild>
        <Link href="/dashboard/digital_workers/new">Começar agora</Link>
      </Button>
    </div>
  )
}
